import { appRoutes } from "@/app/router";
import { observer } from "mobx-react-lite";
import { FC } from "react";
import { Navigate } from "react-router-dom";
import { usePublicAppStore } from "@/store";
import { clientEnvModule } from "@/modules/client-env";
import { localStorageModule } from "@/modules/local-storage";
import { windowModule } from "@/modules/window";
import { shouldRedirectToExternalLandingPage } from "@/app/router/landing-page-redirect";

interface LandingPageProps {}

export const LandingPage: FC<LandingPageProps> = observer(() => {
  const { publicStore } = usePublicAppStore();

  if (publicStore.auth.isAuthenticated) {
    return <Navigate to={appRoutes.notesList({}).path} />;
  }

  const shouldWaitForExternalRedirect = shouldRedirectToExternalLandingPage({
    hasPreviouslyVisitedLoginPage: localStorageModule.hasPreviouslyVisitedLoginPage(),
    hostname: windowModule.getLocationHostname(),
    isDesktop: clientEnvModule.isDesktop(),
    isRootPage: true,
    nodeEnv: clientEnvModule.nodeEnv(),
  });

  if (shouldWaitForExternalRedirect) {
    return null;
  }

  return <Navigate to={appRoutes.logIn({}).path} />;
});
